/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{2C00DEA1-3458-4101-AC94-C11D7877C67B}",
  "sitecoreApiHost": "https://www.fabmisr.com.eg",
  "jssAppName": "Fab2",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/fab2",
  "graphQLEndpoint": "https://www.fabmisr.com.eg/api/fab2?sc_apikey={2C00DEA1-3458-4101-AC94-C11D7877C67B}"
};